import { isToolUIPart } from "ai";
import type { ChatAddToolApprovalResponse } from "./chat-message-renderer-contract";
import type { AgentUIMessage } from "./types";

export type ToolApprovalResponseInput =
  Parameters<ChatAddToolApprovalResponse>[0];

/**
 * AI SDK と同じ状態遷移を純粋関数として適用し、送信前に保存できる snapshot を作る。
 *
 * 対象 approval が末尾 assistant message に存在しない場合は、古い UI や別会話からの
 * 応答を保存・送信しないよう fail closed とする。
 */
export function applyToolApprovalResponse(
  messages: AgentUIMessage[],
  response: ToolApprovalResponseInput,
): AgentUIMessage[] {
  const lastMessage = messages.at(-1);
  if (!lastMessage || lastMessage.role !== "assistant") {
    throw new Error("Tool approval request is no longer available");
  }

  let matched = false;
  const parts = lastMessage.parts.map((part) => {
    if (
      !isToolUIPart(part) ||
      part.state !== "approval-requested" ||
      part.approval.id !== response.id
    ) {
      return part;
    }

    matched = true;
    return {
      ...part,
      state: "approval-responded" as const,
      approval: {
        ...part.approval,
        id: response.id,
        approved: response.approved,
        reason: response.reason,
      },
    };
  });

  if (!matched) {
    throw new Error("Tool approval request is no longer available");
  }

  return [
    ...messages.slice(0, -1),
    {
      ...lastMessage,
      parts,
    },
  ];
}
